import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useIsStatusPage = () => {
    const location = useLocation();
    return useMemo(() => location.pathname === '/status', [location.pathname]);
};
